import {Action, ActionReducer, createReducer, on} from "@ngrx/store";
import * as dataSourcesUsage from "./dataSourcesUsage.actions";
import {
  DataSourcesUsagesState
} from "./dataSourcesUsage";
import {
  initializeDataSourcesUsage,
  initializeDataSourcesUsageDimensionsSuccess,
  initializeDataSourcesUsageMetricsSuccess,
  updateDataSourceState
} from './dataSourcesUsage.actions';
import {Serializer} from '../../interfaces/serializer';
import {DataSource} from '../../interfaces/data-source';
import {DatasetUsageComponentObject} from '../../classes/dataset-usage-component-object';
import {TypedAction} from '@ngrx/store/src/models';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';
import {MetricComponentObjects} from '../../classes/metric-component-object';

const reducer: ActionReducer<DataSourcesUsagesState> = createReducer(
  { serialized: [], componentObjects: [], paid: [], ads: [], sites: [], attribution: null, loading: false, initialized: false },
  on(dataSourcesUsage.loadDataSourcesUsage, (state: DataSourcesUsagesState) => {
    return {
      ...state,
      loading: true,
      loaded: false
    };
  }),
  on(dataSourcesUsage.loadDataSourcesUsageSuccess, (state: DataSourcesUsagesState, action) => {
    return {
      serialized: action.dataSources,
      componentObjects: action.dataSources.map((datasetUsage: Serializer<DataSource>): DatasetUsageComponentObject => new DatasetUsageComponentObject(datasetUsage)),

      paid: action.dataSources.filter(dataSource => dataSource.relationships.data_source.data.attributes.is_paid),
      ads: action.dataSources.filter(dataSource => dataSource.relationships.data_source.data.attributes.centric === 'ad'),
      sites: action.dataSources.filter(dataSource => dataSource.relationships.data_source.data.attributes.centric === 'site'),
      attribution: action.dataSources.find(dataSource => dataSource.relationships.data_source.data.attributes.slug === 'adloop-tracking' ||
        dataSource.relationships.data_source.data.attributes.slug === 'adloop-attribution-legacy'),
      loading: false,
      loaded: true,
      initialized: false
    };
  }),
  on(dataSourcesUsage.updateDataSourceUsageSuccess, (state: DataSourcesUsagesState, action) => {
    state.serialized.splice(state.serialized.findIndex(data => action.dataSource.id === data.id), 1, action.dataSource);

    const componentObject: DatasetUsageComponentObject = state.componentObjects.find((item: DatasetUsageComponentObject): boolean => item.payload.id === action.dataSource.id);
    if (componentObject) {
      componentObject.update(action.dataSource);
    }

    return {
      ...state,
      paid: state.serialized.filter(dataSource => dataSource.relationships.data_source.data.attributes.is_paid),
      ads: state.serialized.filter(dataSource => dataSource.relationships.data_source.data.attributes.centric === 'ad'),
      sites: state.serialized.filter(dataSource => dataSource.relationships.data_source.data.attributes.centric === 'site')
    };
  }),
  on(updateDataSourceState, (state: DataSourcesUsagesState, action) => {
    Object.assign(state.serialized.find(dataSource => dataSource.id === action.dataSource.id).attributes, action.dataSource.attributes);

    return {
      ...state
    };
  }),
  on(initializeDataSourcesUsage, (state: DataSourcesUsagesState): DataSourcesUsagesState => {
    return {
      ...state,
      initialized: false
    };
  }),
  on(initializeDataSourcesUsageDimensionsSuccess, (state: DataSourcesUsagesState, action: TypedAction<string> & { dimensions: DimensionComponentObjects }): DataSourcesUsagesState => {
    state.componentObjects.forEach((componentObject: DatasetUsageComponentObject): void => {
      componentObject.initDimensions(action.dimensions);
    });

    return {
      ...state,
      initialized: true
    };
  }),
  on(initializeDataSourcesUsageMetricsSuccess, (state: DataSourcesUsagesState, action: TypedAction<string> & { metrics: MetricComponentObjects }): DataSourcesUsagesState => {
    state.componentObjects.forEach((componentObject: DatasetUsageComponentObject): void => {
      componentObject.initMetrics(action.metrics);
    });

    return {
      ...state,
      initialized: true
    };
  })
);

export const dataSourcesUsageReducer: ActionReducer<DataSourcesUsagesState> = (state: DataSourcesUsagesState, action: Action) => {
  return reducer(state, action);
};
